export type LayerFilterContext = {
    cfg: any;
    menuItem: any;
    mapsFiltersExpressions?: Record<string, string> | null;
    appliedFilters?: Record<string, any> | null;
};

type LayerFilterRule = {
    when: (ctx: LayerFilterContext) => boolean;
    build: (ctx: LayerFilterContext) => string | null | undefined;
};

const specialRules: LayerFilterRule[] = [
    {
        when: ({ menuItem, cfg }) => (menuItem as any)?.type === "map.RepairPlan" && (cfg?.id === "repairSegments" || cfg?.name === "MARepairSegment"),
        build: ({ appliedFilters }) => {
            const repairPlanId = (appliedFilters as any)?.RepairPlanId;
            return repairPlanId != null ? `RepairPlanId=${repairPlanId}` : null;
        }
    }
];

export function configureWmsLayerFilter(ctx: LayerFilterContext, staticFilter?: string): string {
    const { cfg, mapsFiltersExpressions } = ctx;

    const expressions: string[] = [];

    if (mapsFiltersExpressions && Object.keys(mapsFiltersExpressions).length) {
        if (cfg?.applicableFilters && Array.isArray(cfg.applicableFilters)) {
            const selected = Object.entries(mapsFiltersExpressions)
                .filter(([field]) => cfg.applicableFilters.includes(field))
                .map(([, expr]) => expr)
                .filter(Boolean);
            if (selected.length) expressions.push(selected.join(" and "));
        } else {
            const all = Object.values(mapsFiltersExpressions).filter(Boolean);
            if (all.length) expressions.push(all.join(" and "));
        }
    }

    if (staticFilter) expressions.push(staticFilter);

    for (const rule of specialRules) {
        if (rule.when(ctx)) {
            const extra = rule.build(ctx);
            if (extra) expressions.push(extra);
        }
    }

    return expressions.join(" and ");
}


